import { NEVER, merge } from 'rxjs'
import { filter, switchMap, first, map } from 'rxjs/operators'
import { isArray } from 'libraries/lodash'

const noop = () => undefined

export const accordionGroup = function (cfg) {
  const { stateSource = NEVER, groupSource = NEVER } = cfg

  const flatStateSource = isArray(stateSource) ? merge(...stateSource) : stateSource

  const state = merge(
    flatStateSource,
    flatStateSource
      .pipe(
        map(x => x.expanded),
        filter(s => !!s),
        first(),
        switchMap(() => groupSource.pipe(map(group => ({ group }))))
      )
  )

  return Object.assign(
    {
      className: '',
      disabled: false,
      expandCallback: noop,
      id: '',
      path: [],
      prefix: null,
      selectCallback: noop,
      suffix: null,
      title: null
    },
    cfg,
    {
      nodeType: 'group',
      state
    }
  )
}

export const accordionContent = function (cfg) {
  const { stateSource = NEVER } = cfg

  return Object.assign(
    {
      className: '',
      content: '',
      expandCallback: noop,
      id: '',
      path: [],
      prefix: null,
      selectCallback: noop,
      suffix: null,
      title: null,
      url: null
    },
    cfg,
    {
      nodeType: 'content',
      state: stateSource
    }
  )
}
